import { useEffect, useState } from "react";
import HomeInstall from "./Install";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import SendMessageInputHome from "./Input";
import SendMessageFileHome from "./File";
import SendMessageBtnHome from "./Btn";
import { getSessions } from "../../redux/action/messages/list/listAction";
import { useCookies } from "react-cookie";

const HomeContent = () => {
  const [showEmoji, setShowEmoji] = useState("");
  const [lastEmoji, setLastEmoji] = useState("");

  const [textInput, setTextInput] = useState("");
  const [selectTextInputStart, setSelectTextInputStart] = useState(0);
  const [selectTextInputEnd, setSelectTextInputEnd] = useState(0);

  const [cookies, setCookies] = useCookies(["authToken"]);

  const addEmoji = (event) => {
    const emoji = event.native;

    setLastEmoji(emoji);

    const textStart = textInput.slice(0, selectTextInputStart);
    const textEnd = textInput.slice(selectTextInputEnd);

    setTextInput(textStart + emoji + textEnd);
  };

  const hideEmoji = () => {
    setShowEmoji(false);

    document.body.classList.remove("modal-opened");
  };

  const addMyMessage = (event) => {
    event.preventDefault();

    // send message
    if (textInput.length >= 1) {
      hideEmoji();
    }
  };

  const handleShowEmoji = () => {
    setShowEmoji(!showEmoji);
    if (showEmoji) document.body.classList.remove("modal-opened");
    else document.body.classList.add("modal-opened");
  };

  useEffect(() => {
    getSessions(cookies);
  }, []);

  return (
    <section className="flex flex-col justify-start lg:justify-center items-center lg:h-[calc(100vh-180px)]">
      <HomeInstall />
      <h1 className="w-full lg:hidden text-2xl md:text-4xl font-medium text-center absolute top-[45%] left-1/2 -translate-x-1/2 -translate-y-1/2">
        چطور میتونم کمکتون کنم ؟
      </h1>
      <div className="lg:w-4/5 w-full p-4 select-none bg-custom-gray z-[1] fixed lg:relative bottom-0 left-0">
        <h1 className="hidden lg:block text-4xl font-medium text-center mb-16 ">
          چطور میتونم کمکتون کنم ؟
        </h1>
        <form
          action=""
          className="flex flex-col items-end gap-4 relative bg-white rounded-3xl shadow-custom-lg border-gray-100 border py-3 px-4"
        >
          <SendMessageInputHome
            value={textInput}
            onUpdateTextInput={setTextInput}
            onSetSelectTextInputStart={setSelectTextInputStart}
            onSetSelectTextInputEnd={setSelectTextInputEnd}
            lastEmoji={lastEmoji}
            onHideEmoji={hideEmoji}
            showEmoji={showEmoji}
          />

          <div className="w-full flex justify-between items-center">
            <SendMessageBtnHome
              body={textInput}
              onResetTextValue={setTextInput}
            />

            <div className="flex items-center relative">
              <SendMessageFileHome />

              <button
                onClick={handleShowEmoji}
                className="text-gray-500 3xm:w-10 w-8 h-12 flex items-center justify-center"
                type="button"
              >
                {!showEmoji ? (
                  <ReactSVG
                    src={`${process.env.PUBLIC_URL}/assets/images/icons/emoji.svg`}
                    className="3xm:w-7 3xm:h-7 w-5 h-5"
                  />
                ) : (
                  <ReactSVG
                    src={`${process.env.PUBLIC_URL}/assets/images/icons/times.svg`}
                    className="3xm:w-7 3xm:h-7 w-5 h-5"
                  />
                )}
              </button>

              {showEmoji && (
                <Picker
                  theme="light"
                  previewPosition={"none"}
                  locale={"fa"}
                  data={data}
                  onEmojiSelect={addEmoji}
                  searchPosition={"none"}
                />
              )}
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default HomeContent;
